// textOffset.ts

// Абсолютный индекс символа в text layer для границы (node, offsetInNode).
// Считаем длину Range от начала контейнера до границы — так корректно
// обрабатываются границы, попавшие на элемент, а не на текстовый узел
// (например, выделение до конца строки/страницы), где обход только текстовых
// узлов не нашёл бы node и вернул -1.
export function getTextOffset(
    container: HTMLElement,
    node: Node,
    offsetInNode: number
): number {
    const range = document.createRange();
    range.selectNodeContents(container);
    try {
        range.setEnd(node, offsetInNode);
    } catch {
        return -1;
    }
    return range.toString().length;
}

// Найти текстовый узел и локальный офсет по абсолютному индексу.
// При выходе за пределы — прижимаем к концу последнего текстового узла.
export function findNodeAtOffset(
    container: HTMLElement,
    targetOffset: number
): { node: Text; offset: number } | null {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let total = 0;
    let lastNode: Text | null = null;

    while (walker.nextNode()) {
        const node = walker.currentNode as Text;
        const len = node.textContent!.length;
        lastNode = node;

        if (total + len >= targetOffset) {
            const offset = Math.min(len, Math.max(0, targetOffset - total));
            return { node, offset };
        }
        total += len;
    }

    // targetOffset больше суммарной длины — конец последнего узла
    return lastNode ? { node: lastNode, offset: lastNode.textContent!.length } : null;
}

// Сериализация выделения
export function serializeSelection(container: HTMLElement, range: Range) {
    return {
        startOffset: getTextOffset(container, range.startContainer, range.startOffset),
        endOffset: getTextOffset(container, range.endContainer, range.endOffset),
        text: range.toString()
    };
}

// Восстановление Range по офсетам
export function deserializeRange(
    container: HTMLElement,
    startOffset: number,
    endOffset: number
): Range | null {
    if (startOffset < 0 || endOffset < 0) return null;

    const start = findNodeAtOffset(container, startOffset);
    const end = findNodeAtOffset(container, endOffset);

    if (!start || !end) return null;

    const range = document.createRange();
    range.setStart(start.node, start.offset);
    range.setEnd(end.node, end.offset);
    return range;
}
